import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class RwdFilterFormToggle extends WebComponent {
    didMount() {
        this.element.addEventListener('click', function(e) {
            if (this.classList.contains('opened')) {
                this.classList.remove('opened');
                this.innerHTML = this.dataset.showText;
                document.querySelector('#filterForm').classList.remove('category-filter--show');
            } else {
                this.classList.add('opened');
                this.innerHTML = this.dataset.hideText;
                document.querySelector('#filterForm').classList.add('category-filter--show');
            }
        });
    }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/RwdFilterFormToggle.js